import {ApplicationConfig, importProvidersFrom, LOCALE_ID} from "@angular/core";
import {routes} from "./app.routes";
import {BrowserModule} from "@angular/platform-browser";
import {SharedModule} from "./utils/shared.modules";
import {AgGridModule} from "@ag-grid-community/angular";
import {DialogModule} from "./utils/dialog/dialog.module";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {ServiceWorkerModule} from "@angular/service-worker";
import {HeaderTextService} from "./services/header-text.service";
import {ApplicationInsightsService} from "./services/application-insights.service";
import {DatePipe} from "@angular/common";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {datePickerFormat} from "./utils/date-picker-format.utils";
import {CustomDateAdapter} from "./utils/custom-date-adapter";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {AuthorizationInterceptor} from "./utils/authorization.interceptor";
import {provideAnimations} from "@angular/platform-browser/animations";
import {UserWebservice} from "./services/webservices/user.webservice";
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
  withRouterConfig
} from "@angular/router";
import {provideAuth} from "./services/auth/auth.provider";
import {provideToastr} from "ngx-toastr";

const WEBSERVICES = [
    UserWebservice
];

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(BrowserModule, SharedModule, AgGridModule, DialogModule, MatSlideToggleModule, ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: true,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })),
        provideHttpClient(withInterceptorsFromDi()),
        provideAuth(),
        provideToastr(),
        ...WEBSERVICES,
        HeaderTextService,
        ApplicationInsightsService,
        DatePipe,
        {provide: LOCALE_ID, useValue: 'fr'},
        {provide: MAT_DATE_LOCALE, useValue: 'fr-FR'},
        {provide: MAT_DATE_FORMATS, useValue: datePickerFormat},
        {provide: DateAdapter, useClass: CustomDateAdapter},
        {provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true},
        provideAnimations(),
        provideRouter(
            routes,
            withPreloading(PreloadAllModules),
            withRouterConfig({
                onSameUrlNavigation: 'reload'
            })
        )
    ]
};
